type MenuLink = { href: string; section?: string };

export function ariaCurrentFor(
  { href, section }: MenuLink,
  pathname: string,
  active: string | null
): 'page' | 'true' | undefined {
  if (section) {
    return section === active ? 'true' : undefined;
  }
  return href === pathname ? 'page' : undefined;
}

export function nextFocus(index: number, count: number, backwards: boolean) {
  if (index < 0) {
    return backwards ? count - 1 : 0;
  }
  return (index + (backwards ? count - 1 : 1)) % count;
}
